import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {CP_PANEL_INITIAL_WIDTH} from './constants'

const createReducer = ({
    TASK_MANAGEMENT = {},
}) => {

    const cpPanelWidth = TASK_MANAGEMENT.CP_PANEL_WIDTH || CP_PANEL_INITIAL_WIDTH

    const collapsedCustomersSet = TASK_MANAGEMENT.CP_PANEL_COLLAPSED_CUSTOMERS || {}

    const initialState = {
        resizableMaxWidth: 0,
        width: cpPanelWidth,
        collapsedCustomersSet: collapsedCustomersSet,
        isCustomersAsc: true,
        visibleCustomerIds: [],
        visibleProjectIds: [],
    }

    return handleActions({
        [ActionTypes.CP_PANEL_MAX_WIDTH_CHANGE]: (state, {payload: maxWidth}) => ({
            ...state,
            resizableMaxWidth: maxWidth
        }),
        [ActionTypes.CP_PANEL_WIDTH_CHANGE]: (state, {payload: width}) => ({
            ...state,
            width: width
        }),
        [ActionTypes.CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE]: (state, {payload: collapsedCustomers}) => ({
            ...state,
            collapsedCustomersSet: collapsedCustomers
        }),
        [ActionTypes.CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE]: (state, {payload: visibleCustomerIds}) => ({
            ...state,
            visibleCustomerIds: visibleCustomerIds
        }),
        [ActionTypes.CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE]: (state, {payload: visibleProjectIds}) => ({
            ...state,
            visibleProjectIds: visibleProjectIds
        }),
        [ActionTypes.CP_PANEL_IS_CUSTOMERS_ASC_CHANGE]: (state, {payload: isCustomersAsc}) => ({
            ...state,
            isCustomersAsc: isCustomersAsc
        }),
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/reducer.js